var transportCodeIds = {
  transportBlockToConsumer: 'd86bef57-e975-40f6-b5e3-288489f42e56',
  compositionTransport: 'e503dece-05e5-4372-9026-6fac91710463',
  different: 'cf30e7a8-0760-4f6b-b25c-8729559c3d80'
};
export default transportCodeIds;